import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
//import { Box, Typography, TextField, Avatar, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

const ScotusCommentsReplyPage = () => {
  const [comment, setComment] = useState(null);
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const [replyText, setReplyText] = useState("");
  const [replyChain, setReplyChain] = useState([]);

  const { id, commentId } = useParams();
  const [scotusCase, setScotusCase] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
    const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
    const [activePostId, setActivePostId] = useState(null);

    const [undoDialogOpen, setUndoDialogOpen] = useState(false);
    const [pendingUndoCaseId, setPendingUndoCaseId] = useState(null);
    const [pendingUndoScotusCase, setPendingUndoScotusCase] = useState(null);

    const [replyOpen, setReplyOpen] = useState(false);
    const [activeCommentId, setActiveCommentId] = useState(null);

    const [openVotersDialog, setOpenVotersDialog] = useState(false);
    const [activeVoters, setActiveVoters] = useState([]);
    const [dialogTitle, setDialogTitle] = useState("");

    const [loggedInUser, setLoggedInUser] = useState(null);

    const [voteRationale, setVoteRationale] = useState(null);

 useEffect(() => {
   axios.get(`/scotusCase/${id}`)
     .then(res => setScotusCase(res.data))
     .catch(err => console.error("Error loading bill", err));
 }, [id]);

useEffect(() => {
            axios.get("/user/me")
                .then(res => setLoggedInUser(res.data))
                .catch(() => setLoggedInUser(null));
        }, []);

/*
useEffect(() => {
  const fetchComment = async () => {
    try {
      const res = await axios.get(`/scotusCase/${id}/commentReplies/${commentId}`);
      setComment(res.data);
    } catch (err) {
      console.error("Error fetching comment:", err);
    }
  };

  fetchComment();
}, [commentId]);
*/
/*useEffect(() => {
  const fetchContext = async () => {
    try {
      const res = await axios.get(
        `/scotusCase/${id}/commentReplies/${commentId}`
      );
      setReplyChain(res.data.chain);
      setComment(res.data.current);
    } catch (err) {
      console.error("Error loading comment context", err);
    }
  };

  fetchContext();
}, [id, commentId]);*/
const location = useLocation();
const source = location.state?.source;

const [isLoadingReplies, setIsLoadingReplies] = useState(false);

// Pagination stored in refs — never captured stale in observer closures
const cursorRef = useRef(null);
const hasMoreRef = useRef(true);
const isFetchingRef = useRef(false);
const abortRef = useRef(null);

// ── Stable navigation callbacks — safe to pass to React.memo children ──────
const handleNavigate = useCallback((targetId) => {
 history.push(`/scotusCase/${id}/comments/${targetId}`, { source });
}, [history, id, source]);

// ── Core fetch — reads cursor from ref, never from a stale closure ─────────
 const fetchReplies = useCallback(async (overrideCursor) => {
   if (isFetchingRef.current || !hasMoreRef.current) return;

   abortRef.current?.abort();
   abortRef.current = new AbortController();
   isFetchingRef.current = true;
   setIsLoadingReplies(true);

   // undefined means "use whatever cursorRef holds right now"
   const cursorToUse = overrideCursor !== undefined ? overrideCursor : cursorRef.current;

   try {
     const res = await axios.get(
       `/scotusCase/${id}/commentReplies/${commentId}`,
       {
         params: { cursor: cursorToUse ?? undefined, limit: 10 },
         signal: abortRef.current.signal,
       }
     );

     if (!cursorToUse) {
       // Initial load
       setReplyChain(res.data.chain);
       setComment(res.data.current);
     } else {
       // Append page
       setComment(prev => prev
         ? { ...prev, replies: [...prev.replies, ...res.data.current.replies] }
         : prev
       );
     }

     // Write to refs synchronously — observer always reads current values
     cursorRef.current = res.data.nextCursor;
     hasMoreRef.current = res.data.hasMore;

   } catch (err) {
     if (axios.isCancel(err) || err.name === "CanceledError") return;
     console.error("Fetch replies failed", err);
   } finally {
     isFetchingRef.current = false;
     setIsLoadingReplies(false);
   }
 }, [id, commentId]);

 // ── Reset + initial load whenever route params change ─────────────────────
 useEffect(() => {
   cursorRef.current = null;
   hasMoreRef.current = true;
   isFetchingRef.current = false;
   setComment(null);
   setReplyChain([]);
   fetchReplies(null);
   return () => abortRef.current?.abort();
 }, [id, commentId, fetchReplies]);

 // ── IntersectionObserver on a SEPARATE sentinel div, not the last card ─────
 // This is what makes click + observer mutually exclusive at the DOM level.
 const observerRef = useRef();
 const sentinelRef = useCallback(node => {
   if (observerRef.current) observerRef.current.disconnect();
   if (!node) return;
   observerRef.current = new IntersectionObserver(entries => {
     if (entries[0].isIntersecting && hasMoreRef.current && !isFetchingRef.current) {
       fetchReplies(undefined); // reads cursorRef.current internally
     }
   }, { rootMargin: "300px" });
   observerRef.current.observe(node);
 }, [fetchReplies]);

 const handleSubmit = async () => {
   try {
     await axios.post('/api/govPosts', {
       title,
       content,
       topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
     });
     setOpen(false);
     setTitle('');
     setContent('');
     alert('Post created!');
   } catch (err) {
     console.error('Failed to create post', err);
   }
 };

 const toggleVote = async (scotusCaseId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/upvote`);
            const { upvotes, voted } = res.data;


            setScotusCase(prevCase => ({
                ...prevCase,
                upvoteCount: upvotes,
                voted
            }));
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const isSameUser = (voteUser, loggedInUserId) => {
      if (!voteUser) return false;
      return typeof voteUser === "string"
          ? voteUser === loggedInUserId
          : voteUser._id === loggedInUserId;
  };

  const toggleForPetitioner = async (scotusCaseId, commentId) => {
        try {
            const res = await axios.post(
                `/scotusCase/${scotusCaseId}/petitioner`,
                { commentId }
            );

            const { upvotes, scotusCaseVoted } = res.data;

            setScotusCase(prev => {
                if (!prev || prev._id !== scotusCaseId) return prev;

                return {
                    ...prev,

                    petitionerCount: upvotes,
                    //scotusCaseVoted,

                    votedScotusCase: true,
                    votedSide: "petitioner",

                    // update voters 
                    /*scotusCaseVoters: [
                        ...(prev.scotusCaseVoters || []).filter(
                            v => !isSameUser(v, loggedInUser._id)
                        ),
                        {
                            _id: loggedInUser._id,
                            username: loggedInUser.username,
                            first_name: loggedInUser.first_name,
                            last_name: loggedInUser.last_name,
                            profileImageUrl: loggedInUser.profileImageUrl,
                            tier: loggedInUser.tier,
                        },
                    ],

                    // add petitioner vote (deduped)
                    petitionerPowerVotes: [
                        ...(prev.petitionerPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),
                        {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                        },
                    ],

                    // ensure respondent side is clean
                    respondentPowerVotes: (prev.respondentPowerVotes || []).filter(
                        v => !isSameUser(v.user, loggedInUser._id)
                    ),*/
                };
            });
        } catch (err) {
            console.error("Error toggling vote:", err);
        }
    };

  const toggleForRespondent = async (scotusCaseId, commentId) => {
        try {
            const res = await axios.post(
                `/scotusCase/${scotusCaseId}/respondent`,
                { commentId }
            );

            const { upvotes, scotusCaseVoted } = res.data;

            setScotusCase(prev => {
                if (!prev || prev._id !== scotusCaseId) return prev;

                return {
                    ...prev,

                    respondentCount: upvotes,

                    votedScotusCase: true,
                    votedSide: "respondent",
                    /*scotusCaseVoted,

                    // update voters 
                    scotusCaseVoters: [
                        ...(prev.scotusCaseVoters || []).filter(
                            v => !isSameUser(v, loggedInUser._id)
                        ),
                        {
                            _id: loggedInUser._id,
                            username: loggedInUser.username,
                            first_name: loggedInUser.first_name,
                            last_name: loggedInUser.last_name,
                            profileImageUrl: loggedInUser.profileImageUrl,
                            tier: loggedInUser.tier,
                        },
                    ],

                    // add respondent vote
                    respondentPowerVotes: [
                        ...(prev.respondentPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),
                        {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                        },
                    ],

                    // ensure petitioner side is clean
                    petitionerPowerVotes: (prev.petitionerPowerVotes || []).filter(
                        v => !isSameUser(v.user, loggedInUser._id)
                    ),*/
                };
            });
        } catch (err) {
            console.error("Error toggling vote:", err);
        }
    };

    const handleOpenDialog = (scotusCaseId) => {
       setActivePostId(scotusCaseId);
       setOpenDialog(true);
    };

    const handleSubmitVote = async () => {
        if (!voteType || !voteRationale.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }

        try {
            const commentRes = await axios.post(
                `/scotusCase/${activePostId}/comment`,
                { text: voteRationale }
            );

            const commentId = commentRes.data._id; 

            //const getCommentRes = await axios.get(`/scotusCase/${id}/comments`);
            //setComments(getCommentRes.data);
            const res = await axios.get(
              `/scotusCase/${id}/commentReplies/${commentId}`
            );
            setReplyChain(res.data.chain);
            setComment(res.data.current);

            if (voteType === "For Petitioner") {
                await toggleForPetitioner(activePostId, commentId);
            } else {
                await toggleForRespondent(activePostId, commentId);
            }
            setOpenDialog(false);
            setVoteRationale("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };

    /*const handleUndoVote = async (scotusCaseId, scotusCase) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/undoVote`);
            const { upvotes, scotusCaseVoted, deletedCommentId } = res.data;

            const votedPetitioner = scotusCase?.petitionerPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            );

            const votedRespondent = scotusCase?.respondentPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            );

            setScotusCase(prev => {
                if (!prev || prev._id !== scotusCaseId) return prev;

                return {
                    ...prev,

                    scotusCaseVoted,

                    // update counts
                    ...(votedPetitioner ? { petitionerCount: upvotes } : {}),
                    ...(votedRespondent ? { respondentCount: upvotes } : {}),

                    // remove from global voters
                    scotusCaseVoters: (prev.scotusCaseVoters || []).filter(
                        v => !isSameUser(v, loggedInUser._id)
                    ),

                    // remove from vote arrays
                    petitionerPowerVotes: (prev.petitionerPowerVotes || []).filter(
                        v => !isSameUser(v.user, loggedInUser._id)
                    ),

                    respondentPowerVotes: (prev.respondentPowerVotes || []).filter(
                        v => !isSameUser(v.user, loggedInUser._id)
                    ),
                };
            });

            //setComments(prev =>
            //    prev.filter(comment => comment._id !== deletedCommentId)
            //);
            const commentRes = await axios.get(
              `/scotusCase/${id}/commentReplies/${commentId}`
            );
            setReplyChain(commentRes.data.chain);
            setComment(commentRes.data.current);
        } catch (err) {
            console.error("Error undoing vote:", err);
        }
    };*/
    const handleUndoVote = async (scotusCaseId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/undoVote`);
            const { upvotes, deletedCommentId } = res.data;

            // Update case state (O(1), no arrays)
            setScotusCase(prev => {
                if (!prev || prev._id !== scotusCaseId) return prev;

                const updated = { ...prev };

                // Use source of truth
                if (prev.votedSide === "petitioner") {
                    updated.petitionerCount = upvotes;
                } else if (prev.votedSide === "respondent") {
                    updated.respondentCount = upvotes;
                }

                // Reset vote state (THIS fixes your UI instantly)
                updated.votedScotusCase = false;
                updated.votedSide = null;

                return updated;
            });

            // Remove deleted comment (if exists)
            /*if (deletedCommentId) {
            setComments(prev =>
                prev.filter(c => c._id !== deletedCommentId)
            );
            }*/
           const commentRes = await axios.get(
              `/scotusCase/${id}/commentReplies/${commentId}`
            );
            setReplyChain(commentRes.data.chain);
            setComment(commentRes.data.current);

        } catch (err) {
            console.error("Error undoing vote:", err);
        }
    };

    /*const openPetitionerVoters = (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Petitioner Votes");
        setActiveVoters(scotusCase.petitionerPowerVotes || []);
        setOpenVotersDialog(true);
    };

    const openRespondentVoters = (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Respondent Votes");
        setActiveVoters(scotusCase.respondentPowerVotes || []);
        setOpenVotersDialog(true);
    };*/
    /*
    const openPetitionerVoters = async (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Petitioner Votes");

        try {
            const res = await axios.get(`/scotusCase/${scotusCase._id}/voters?side=petitioner`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };

    const openRespondentVoters = async (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Respondent Votes");

        try {
            const res = await axios.get(`/scotusCase/${scotusCase._id}/voters?side=respondent`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };*/

    //const scotusRespondentCount = scotusCase.respondentCount || 0;
    console.log(scotusCase);
    const scotusRespondentCount = scotusCase?.respondentCount ?? 0;
    console.log(scotusRespondentCount);
    
    const scotusPetitionerCount = scotusCase?.petitionerCount ?? 0;
    let votePercentage = 0;
 
    if (scotusRespondentCount > scotusPetitionerCount) {
        votePercentage =scotusRespondentCount/(scotusRespondentCount+scotusPetitionerCount)
    } else if (scotusPetitionerCount > scotusRespondentCount) {
        votePercentage = scotusPetitionerCount/(scotusRespondentCount+scotusPetitionerCount)
    }

    let offset = 0;
    if (scotusRespondentCount > scotusPetitionerCount) {
        offset = votePercentage * 50; // move right
    } else if (scotusPetitionerCount > scotusRespondentCount) {
        offset = -votePercentage * 50; // move left
    }

    let tickColor = "blue"; // default at center
    if (offset > 0) {
        tickColor = "red"; // right side
    } else if (offset < 0) {
        tickColor = "red"; // left side
    }

    const CommentCard = ({ comment }) => (
  <Box
    p={2} // padding inside box
    my={2} // vertical margin between posts
    //onClick={() => history.push(`/scotusCase/${id}/comments/${comment._id}`)}
    onClick={() => handleNavigate(comment._id)}
    border="1px solid #ccc" // light grey border
    borderRadius="8px" // rounded corners
    sx={{
      position: "relative",
      maxWidth: 900, // limit width
      mx: "auto", // center horizontally
      my: 2, // vertical spacing between each post
      cursor: "pointer",
                 "&:hover": {
                     backgroundColor: "#f9f9f9"
                 }
    }}
  >
    <Box display="flex" alignItems="flex-start" gap={1}>
      <Avatar
        src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
        onClick={(e) => visitProfile(e, comment.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
      />
      <Box>
        <Typography variant="subtitle1" fontWeight="bold"
        onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
        >
          {comment.author?.first_name} {comment.author?.last_name}
        </Typography>
        <Typography variant="body2" color="text.secondary"
        onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
        >
          @{comment.author?.username}
        </Typography>
        <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
          {comment.text}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount ?? 0
                                        } ${comment.replyCount === 1 ? "reply" : "replies"}`}
                                    </Typography>
      </Box>
    </Box>

    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {comment.replyVoted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleReplyVote(comment._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(comment._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                   </Box>
  </Box>
);

 const toggleCommentVote = async (commentId) => {
       try {
            // hit backend endpoint that toggles a vote
           const res = await axios.post(`/scotusCaseComments/${commentId}/upvote`);


           setComment(prev => ({
               ...prev,
               upvotes: res.data.upvotes,
               voted: res.data.voted
           }));
        } catch(err) {
           console.error("Vote error", err);
       }
   };
       // Recursively update a reply at any depth
   /*function updateReplyRecursive(replies, replyId, newData) {
     return (replies || []).map((r) => {
       if (r._id === replyId) {
         return { ...r, ...newData }; // update this reply
       }
       return {
         ...r,
         replies: updateReplyRecursive(r.replies, replyId, newData), // recurse
       };
     });
   }


   const toggleReplyVote = async (replyId) => {
     try {
       const res = await axios.post(`/scotusCase/${id}/commentReplies/${replyId}/upvote`);
       const { replyUpvotes, replyVoted } = res.data;


       setComment((prev) => {
         if (!prev) return prev;


         // Case A: this comment itself is the reply
         if (prev._id === replyId) {
           return {
             ...prev,
             replyUpvotes,
             replyVoted,
           };
         }


         // Case B: it's somewhere in prev.replies (any depth)
         return {
           ...prev,
           replies: updateReplyRecursive(prev.replies, replyId, {
             replyUpvotes,
             replyVoted,
           }),
         };
       });
     } catch (err) {
       console.error("Reply vote error", err);
     }
   };
       console.log(comment);*/
    const updateReplyChainRecursive = (nodes = [], id, updates) => {
   let changed = false;

   const next = nodes.map((n) => {
     if (n._id === id) {
       changed = true;
       return { ...n, ...updates };
     }

     const updatedReplies = updateReplyChainRecursive(n.replies, id, updates);
     if (updatedReplies !== n.replies) {
       changed = true;
       return { ...n, replies: updatedReplies };
     }

     return n;
   });

   return changed ? next : nodes;
 };

 const updateReplyRecursive = (replies = [], replyId, updates) => {
   return replies.map((r) => {
     if (r._id === replyId) {
       return { ...r, ...updates };
     }

     return {
       ...r,
       replies: updateReplyRecursive(r.replies, replyId, updates),
     };
   });
 };

 const toggleReplyVote = async (replyId) => {
   try {
     const res = await axios.post(
       `/scotusCase/${id}/commentReplies/${replyId}/upvote`
     );

     const { replyUpvotes, replyVoted } = res.data;

     setComment((prev) => {
       if (!prev) return prev;

       // Case A: current focused comment is the reply
       if (prev._id === replyId) {
         return {
           ...prev,
           replyUpvotes,
           replyVoted,
         };
       }

       // Case B: reply exists somewhere in the chain
       return {
         ...prev,
         replies: updateReplyRecursive(prev.replies, replyId, {
           replyUpvotes,
           replyVoted,
         }),
       };
     });

     setReplyChain((prev) =>
       updateReplyChainRecursive(prev, replyId, {
         replyUpvotes,
         replyVoted,
       })
     );
   } catch (err) {
     console.error("Reply vote error", err);
   }
 };
   /*const handleReplySubmit = async () => {
     if (!replyText.trim()) return;

     try {
       const res = await axios.post(`/scotusCase/comments/${comment._id}/replies`, {
         text: replyText
       });

      setComment(prev => ({
       ...prev,
       replies: [
           ...(prev.replies || []), res.data]
       }));

      setReplyText("");
     } catch (err) {
       console.error("Reply error", err);
     }
   };
   //console.log(comment);*/
   const handleReplySubmit = async () => {
    if (!replyText.trim()) return;

    try {
      const res = await axios.post(`/scotusComments/${comment._id}/reply`, {
        text: replyText,
      });

      const commentRes = await axios.get(
         `/scotusCase/${id}/commentReplies/${commentId}`
      );
      setReplyChain(commentRes.data.chain);
      setComment(commentRes.data.current);
      setReplyText("");
    } catch (err) {
      console.error("Reply error", err);
    }
  };
 if (!comment) return <Typography>Loading...</Typography>;


 const isTopLevel = scotusCase?.comments?.some(c => c._id === comment._id);


 function addReplyRecursive(comment, targetId, newReply) {
   // if this comment/reply matches the target, append the new reply
   if (comment._id === targetId) {
     return {
       ...comment,
       replies: [...(comment.replies || []), newReply]
     };
   }




   // otherwise, dive into nested replies
   return {
     ...comment,
     replies: comment.replies?.map(r => addReplyRecursive(r, targetId, newReply)) || []
   };
 }


const handleReplyCommentSubmit = async (targetId) => {
if (!replyText.trim()) return;
try {
  const res = await axios.post(`/scotusCase/${id}/replyComments/${targetId}/replies`, {
    text: replyText
  });




  const newReply = res.data;




  // update the state recursively
  setComment(prev => addReplyRecursive(prev, targetId, newReply));




  setReplyText("");
} catch (err) {
  console.error("Reply error", err);
}
};

const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };
const navItems = [
        {
            label: "Popular Opinion",
            path: "/Government/popular",
            matchPaths: ["/Government/popular"]
        },
        {
            label: "Following",
            path: "/Government/following",
            matchPaths: ["/Government/following"]
        },
        {
            label: "Supreme Court",
            path: "/Government/SupremeCourt",
            matchPaths: [
            "/Government/SupremeCourt",
            "/scotusCase"
            ]
        },
        {
            label: "Congressional Bills",
            path: "/Government/CongressionalBills",
            matchPaths: ["/page2/b"]
        },
        {
            label: "State Legislature Bills",
            path: "/Government/StateBills",
            matchPaths: ["/Government/StateBills"]
        },
        {
            label: "Elections",
            path: "/Government/Elections/GubernatorialElections",
            matchPaths: ["/Government/Elections"]
        }
    ];

    //const location = useLocation();

    const isActive = (item) => {
        return item.matchPaths.some((match) =>
            location.pathname.startsWith(match)
        );
        };

        const getButtonStyles = (item) => {
        const active = isActive(item);

        return {
            padding: "6px 12px",
            borderColor: active ? "#1f1f1f" : "#333333",
            color: active ? "#1f1f1f" : "#333333",
            backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
            fontWeight: active ? 600 : 500,
            transition: "all 0.15s ease",
            "&:hover": {
            borderColor: "black",
            color: "black",
            backgroundColor: "rgba(0,0,0,0.12)"
            }
        };
    };
 return (
   <div
           style={{
               padding: '20px',
               backgroundColor: '#FFFDF8',
               minHeight: '100vh',  // ensures it covers the full viewport height
               boxSizing: 'border-box', // ensures padding doesn't affect layout
           }}
       >


           <div style={{ width: '200px' }}></div>


           {/* Centered Buttons */}
           {/*<Box
               display="flex"
               justifyContent="center"
               alignItems="center"
               gap={2}
               flexWrap="wrap"
               sx={{
                   mt: 4,
                   mb: 4,
               }}
                   >
                     <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
       </Box>*/}
       <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: "#FFFDF8",
                    py: 2
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                >
                    {navItems.map((item) => (
                    <Button
                        key={item.path}
                        variant="outlined"
                        sx={getButtonStyles(item)}
                        onClick={() => history.push(item.path)}
                    >
                        {item.label}
                    </Button>
                    ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
            </Box>
       {/* Original Scotus Case Display */}
            <Box
                p={2} // padding inside box
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                onClick={() => history.push(`/scotusCase/${scotusCase._id}/comments`)}
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "#f9f9f9"
                    }
                }}
            >
                {/*<Button
                    onClick={(e) => {
                        e.stopPropagation(); 
                        joinVideoCall(bill._id)}
                    }
                    variant="outlined"
                    size="small"
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 1
                    }}
                >
                    Join Voice Call
                </Button>*/}

                <Typography
                    fontWeight="bold"
                    sx={{
                        wordBreak: "break-word",
                        pr: "140px",
                        mb: 1
                    }}
                >
                    {scotusCase?.name}
                </Typography>

                {/*<Box
                    display="flex"
                    justifyContent="center"
                    sx={{
                        mb: 2,
                        //my: 1
                    }}
                >
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleOpenDialog(scotusCase._id)}
                        //sx={{ ml: 2.3 }}
                        sx={{ mr: 2.3 }}
                    >
                        Vote
                    </Button>
                </Box>*/}
                {/*<Box
                display="flex"
                justifyContent="center"
                sx={{ mb: 2 }}
            >
                {loggedInUser &&
                    scotusCase?.scotusCaseVoters?.some(voter =>
                        isSameUser(voter, loggedInUser._id)
                ) ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": {
                            display: "none",
                            },
                            "&:hover .undo-btn": {
                            display: "inline-flex",
                            },
                        }}
                    >
                    {loggedInUser &&
                    scotusCase?.petitionerPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ mr: 2.3 }}
                    >
                        Voted For Petitioner
                    </Button>
                    ) : loggedInUser && scotusCase?.respondentPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                    ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ mr: 2.3 }}
                    >
                        Voted For Respondent
                    </Button>
                    ) : null}
                    <Button
                        className="undo-btn"
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ display: "none", mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            //handleUndoVote(scotusCase._id, scotusCase);
                            setPendingUndoCaseId(scotusCase._id);
                            setPendingUndoScotusCase(scotusCase);
                            setUndoDialogOpen(true);
                        }}
                    >
                        Undo Vote
                    </Button>
                </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(scotusCase._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>*/}
            <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
                {loggedInUser && scotusCase?.votedScotusCase ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": { display: "none" },
                            "&:hover .undo-btn":  { display: "inline-flex" },
                        }}
                    >
                        <Button
                            className="voted-btn"
                            variant="outlined"
                            size="small"
                            disabled
                            sx={{ mr: 2.3 }}
                        >
                            {scotusCase.votedSide === "petitioner"
                            ? "Voted For Petitioner"
                            : "Voted For Respondent"}
                        </Button>
                        <Button
                            className="undo-btn"
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ display: "none", mr: 2.3 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setPendingUndoCaseId(scotusCase._id);
                                setPendingUndoScotusCase(scotusCase);
                                setUndoDialogOpen(true);
                            }}
                        >
                            Undo Vote
                        </Button>
                    </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(scotusCase._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>

                {/* Vote bar with tick */}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ mb: 2 }}
                    >
                    <Typography variant="body2">For Petitioner</Typography>


                    {/* Bar with tick in middle */}
                    <Box
                        sx={{
                            position: "relative",
                            height: "2px",
                            backgroundColor: "#ccc",
                            width: "300px",
                            mx: 2
                        }}>
                            {/* Tick in the center */}
                            <Box sx={{
                                position: "absolute",
                                top: "-6px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "2px",
                                height: "14px",
                                backgroundColor: "black"
                            }} />
                        
                        {/* Dynamic tick + percentage */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: "-6px",
                                left: `calc(50% + ${offset}%)`,
                                transform: "translateX(-50%)",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            }}
                            >
                            {/* Tick */}
                            <Box sx={{
                                width: "2px",
                                height: "14px",
                                backgroundColor: tickColor
                            }} />


                            {/* Percentage */}
                            <Typography
                                variant="caption"
                                sx={{ mt: "2px", fontSize: "0.7rem" }}
                            >
                                {(votePercentage * 100).toFixed(0)}%
                            </Typography>
                            </Box>
                        </Box>


                        <Typography variant="body2">For Respondent</Typography>
                </Box>

                <Link
                    href={scotusCase?.pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View PDF
                    </Link>


                <Box mt={2} display="flex" alignItems="center" gap={1}>
                    <Button
                        size="small"
                        variant={scotusCase?.voted ? "contained" : "outlined"}
                        onClick={() => toggleVote(scotusCase._id)}
                    >
                        ▲ {scotusCase?.voted ? "Unvote" : "Upvote"}
                    </Button>
                    {/*<Typography variant="body2">{scotusCase?.upvoteCount} Visibility Upvotes | {scotusCase?.petitionerCount} For Petitioner Votes | {scotusCase?.respondentCount} For Respondent Votes</Typography>*/}
                    <Typography variant="body2">
                        {scotusCase?.upvoteCount} Visibility Upvotes |{" "}
                        <Box
                            component="span"
                            sx={{ color: "primary.main", }}
                            //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                            //onClick={(e) => openPetitionerVoters(e, scotusCase)}
                        >
                            {scotusCase?.petitionerCount} For Petitioner Votes
                        </Box>{" "}
                        |{" "}
                        <Box
                            component="span"
                            sx={{ color: "primary.main", }}
                            //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                            //onClick={(e) => openRespondentVoters(e, scotusCase)}
                        >
                            {scotusCase?.respondentCount} For Respondent Votes
                        </Box>
                </Typography>
                </Box>

            </Box>
            {/* --- Dialog --- */}
           <Dialog 
            open={openDialog} 
            onClose={() => setOpenDialog(false)} 
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
               <DialogTitle>Cast Your Power Vote</DialogTitle>
               <DialogContent>
                   <Box display="flex" gap={2} mb={2}>
                       <Button
                           variant={voteType === "For Petitioner" ? "contained" : "outlined"}
                           onClick={() => setVoteType("For Petitioner")}
                       >
                           For Petitioner
                       </Button>
                       <Button
                           variant={voteType === "For Respondent" ? "contained" : "outlined"}
                           onClick={() => setVoteType("For Respondent")}
                       >
                           For Respondent
                       </Button>
                   </Box>
                   <TextField
                       fullWidth
                       multiline
                       rows={3}
                       placeholder="Explain your power vote (required)"
                       value={voteRationale}
                       onChange={(e) => setVoteRationale(e.target.value)}
                   />
               </DialogContent>
               <DialogActions>
                   <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                   <Button
                       variant="outlined"
                       onClick={handleSubmitVote}
                       disabled={!voteRationale || !voteType}
                   >
                       Submit Power Vote
                   </Button>
               </DialogActions>
           </Dialog>

           <Dialog
                open={undoDialogOpen}
                onClose={() => setUndoDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                        px: 2,
                        py: 1.5,
                    },
                }}
                >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Undo your vote?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ color: "text.primary" }}>
                        This will remove your vote and the vote rationale comment associated with it.
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ pb: 2, px: 3 }}>
                    <Button
                        onClick={() => setUndoDialogOpen(false)}
                        variant="outlined"
                        sx={{
                            borderColor: "#d0cfc8",
                            color: "text.primary",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={() => {
                            handleUndoVote(pendingUndoCaseId, pendingUndoScotusCase);
                            setUndoDialogOpen(false);
                            setPendingUndoCaseId(null);
                            setPendingUndoScotusCase(null);
                        }}
                        variant="contained"
                        color="error"
                        sx={{
                            boxShadow: "none",
                        }}
                    >
                        Yes, Undo Vote
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openVotersDialog}
                onClose={() => setOpenVotersDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {dialogTitle}
                </DialogTitle>

                <DialogContent dividers>
                    {activeVoters.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No votes
                    </Typography>
                    ) : (
                    <List disablePadding>
                        {activeVoters.map(vote => (
                        <ListItem 
                            key={vote.user._id} 
                            button
                            onClick={(e) => visitProfile(e, vote.user._id)}
                            sx={{
                                px: 0,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#FFF2CC', // subtle highlight
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                {/* Left side: Avatar + user info */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemAvatar>
                                    <Avatar src={vote.user.profileImageUrl}>
                                        {vote.user.username?.[0]}
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                        secondary={`@${vote.user.username}`}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Voting Power: {vote.user.tier}
                                </Typography>
                            </Box>
                        </ListItem>
                        ))}
                    </List>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenVotersDialog(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
  {/* Reply chain */}
        {replyChain.map((c) => (
          <CommentCard
            key={c._id}
            comment={c}
          />
        ))}
   <Box
             p={2} // padding inside box
             my={2} // vertical margin between posts
             border="1px solid #ccc" // light grey border
             borderRadius="8px" // rounded corners
             sx={{
                 position: "relative",
                 maxWidth: 900, // limit width
                 mx: "auto", // center horizontally
                 my: 2, // vertical spacing between each post
             }}
       >
     {/* original comment */}
     <Box display="flex" alignItems="flex-start" gap={1}>
       <Avatar
         src={comment.author?.profileImageUrl || "/default-avatar.jpg"}
         onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{ 
                                        width: 62, 
                                        height: 62,
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "#d9e4f0",
                                        }, 
                                        }}
       />
       <Box>
         <Typography variant="subtitle1" fontWeight="bold"
         onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
         >
           {comment.author?.first_name} {comment.author?.last_name}
         </Typography>
         <Typography variant="body2" color="text.secondary"
         onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
         >
           @{comment.author?.username}
         </Typography>
         <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
           {comment.text}
         </Typography>
         <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
          {`${new Date(comment.created_at).toLocaleString()}, ${
            comment.replyCount
          } ${comment.replyCount === 1 ? "reply" : "replies"}`}
        </Typography>
       </Box>
     </Box>


     {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                           <Button
                               size="small"
                               variant={
                                 isTopLevel
                                   ? (comment.voted ? "contained" : "outlined")
                                   : (comment.replyVoted ? "contained" : "outlined")
                               }
                               onClick={(e) => {
                                 e.stopPropagation();
                                 if (isTopLevel) {
                                   toggleCommentVote(comment._id);
                                 } else {
                                   toggleReplyVote(comment._id);
                                 }}
                               }
                           >
                               ▲ {isTopLevel
                                 ? (comment.voted ? "Unvote" : "Upvote")
                                 : (comment.replyVoted ? "Unvote" : "Upvote")}
                           </Button>
                           <Typography variant="body2">
                             {isTopLevel ? comment.upvotes : comment.replyUpvotes} upvotes
                           </Typography>
                       </Box>*/}
        <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.replyVoted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReplyVote(comment._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleReplyVote(comment._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.replyUpvotes} Power Votes</Typography>
                    </Box>
   </Box>
   {/* Comment Form */}
     <Box
           p={2} // padding inside box
           my={2} // vertical margin between posts
           border="1px solid #ccc" // light grey border
           borderRadius="8px" // rounded corners
           sx={{
               position: "relative",
               maxWidth: 900, // limit width
               mx: "auto", // center horizontally
               my: 2, // vertical spacing between each post
           }}
       >
       <TextField
         fullWidth
         multiline
         rows={2}
         placeholder="Engage in intellectual discourse..."
         value={replyText}
         onChange={(e) => setReplyText(e.target.value)}
       />
       <Button
         variant="outlined"
         sx={{ mt: 1 }}
         onClick={(e) => {
            e.stopPropagation();
            handleReplySubmit();
          }}
       >
         Reply
       </Button>
     </Box>
     {/* replies */}
       {comment.replies.length != 0 || hasMoreRef.current ? (
         comment.replies.map((reply, i) => {
            const isLast = i === comment.replies.length - 1;

            return (
           <Box
             p={2} // padding inside box
             key={reply._id}
             //onClick={() => history.push(`/scotusCase/${id}/comments/${reply._id}`)}
             ref={isLast ? sentinelRef : null}
             onClick={() => handleNavigate(reply._id)}
             my={2} // vertical margin between posts
             border="1px solid #ccc" // light grey border
             borderRadius="8px" // rounded corners
             sx={{
                 position: "relative",
                 maxWidth: 900, // limit width
                 mx: "auto", // center horizontally
                 my: 2, // vertical spacing between each post
                 cursor: "pointer",
                 "&:hover": {
                     backgroundColor: "#f9f9f9"
                 }
             }}
       >
           <Box display="flex" alignItems="flex-start" gap={1}>
                           <Avatar
                               src={reply.author?.profileImageUrl || '/default-avatar.jpg'}
                               alt={`${reply.author?.first_name || ''} ${reply.author?.last_name || ''}`}
                               onClick={(e) => visitProfile(e, reply.author?._id)}
                                    sx={{ 
                                        width: 62, 
                                        height: 62,
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "#d9e4f0",
                                        }, 
                                        }}
                           />
                           <Box>
                               <Typography variant="subtitle1" fontWeight="bold"
                               onClick={(e) => visitProfile(e, reply.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                               >
                               {reply.author?.first_name && reply.author?.last_name
                                   ? `${reply.author.first_name} ${reply.author.last_name}`
                                   : 'Unknown Name'}
                               </Typography>
                               <Typography variant="body2" color="text.secondary"
                               onClick={(e) => visitProfile(e, reply.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                               >
                               @{reply.author?.username || 'unknown'}
                               </Typography>


                               {/* Post content */}
                               <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                   {reply.text}
                               </Typography>


                               {/* Date */}
                               <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{ display: "block", mt: 0.5 }}
                                >
                                  {`${new Date(reply.created_at).toLocaleString()}, ${
                                    reply.replyCount ?? 0
                                  } ${reply.replyCount === 1 ? "reply" : "replies"}`}
                                </Typography>


                           </Box>
                       </Box>
              
             {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                           <Button
                               size="small"
                               variant={reply.replyVoted ? "contained" : "outlined"}
                               onClick={(e) => {
                                 e.stopPropagation();
                                 toggleReplyVote(reply._id)}
                               }
                           >
                               ▲ {reply.replyVoted ? "Unvote" : "Upvote"}
                           </Button>
                           <Typography variant="body2">{reply.replyUpvotes} upvotes</Typography>
                       </Box>*/}
              <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {reply.replyVoted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleReplyVote(reply._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleReplyVote(reply._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{reply.replyUpvotes} Power Votes</Typography>
                   </Box>
           </Box>
         )})
       ) : (
         <Typography></Typography>
       )}
   </div>
 );
};


export default ScotusCommentsReplyPage;
